import { createList } from 'shared/pages'
export default [
  {
    path: '',
    name: 'service_list',
    component: () =>
      import('./List').then(config => createList(config.default)),
  },
  {
    path: 'create',
    name: 'service_new',
    component: () => import('./New'),
  },
  {
    path: ':id/edit',
    name: 'service_edit',
    component: () => import('./Edit'),
    props: true,
  },
]
